import React, { Component } from 'react'
import Header from '../Header'
import './VIIIw.css'

class VIIIw extends Component {
  
    render () {
        return (
            <div>
                <Header />
                <div className="bodyVIIIw">
                    <p className="textVIIIw">A venir...</p>
                </div>
            </div>
        )
    }
}

export default VIIIw